import React, { useState } from 'react';

interface IProps {
  closeModal: () => void;
}

const MergerAnnouncement: React.FC<IProps> = ({ closeModal }: IProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleDontShowAgain = () => {
    setDontShowAgain(!dontShowAgain);
  };

  const handleClose = () => {
    if (dontShowAgain) {
      // Set the current date as value - this will expire at the end of the day
      const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      localStorage.setItem('hideLocalStitchMergerPopup', today);
    }
    closeModal();
  };

  return (
    <div className="dimd-layer">
      <div className="announcement-popup">
        <div className="announcement-header">
          <h2>로컬스티치 합병 안내</h2>
          <button type="button" className="btn-close" onClick={handleClose}>
            <span className="img-close" />
          </button>
        </div>

        <div className="announcement-content">
          <div className="announcement-text">
            <p>안녕하세요. 로컬스티치 대표 김수민입니다.</p>
            <p>차가운 바람 끝자락을 지나 완연한 봄이 성큼 다가왔습니다.</p>
            <p>로컬스티치에도 새로운 소식이 있어 이렇게 인사드립니다.</p>

            <p className="spacing" />

            <p>주식회사 로컬스티치는 2025년 6월 1일을 기점으로</p>
            <p>SK디앤디(SK D&D)의 부동산 운영 전문 자회사인</p>
            <p>
              주식회사 디앤디프라퍼티솔루션(DDPS)과 하나 되어 더욱 큰 발걸음을
              내딛게 되었습니다.
            </p>

            <p className="spacing" />

            <p>이번 합병은 로컬스티치가 가진 지역 기반 콘텐츠와</p>
            <p>DDPS의 전문적인 부동산 운영 노하우의 시너지를 통해</p>
            <p>
              더욱 혁신적인 공간 경험을 창출하고, 새로운 가치를 만들어나가는데
              중요한 발판이 될 것입니다.
            </p>

            <p className="spacing" />

            <p>
              더불어 로컬스티치 멤버십과 브랜드 파트너십은 기존대로 유지되며
            </p>
            <p>
              에피소드가 보유한 다양한 네트워크와 결합되어 더 좋은 서비스를
              제공할 것을 약속드립니다.
            </p>

            <p className="spacing" />

            <p>
              그동안 로컬스티치는 도시 창작자들이 함께 성장하고 서로 지지하며
            </p>
            <p>꿈을 펼칠 수 있는 기회를 만들고자 노력해 왔습니다.</p>
            <p>
              지금까지 저희의 여정에 보내주신 따뜻한 관심과 응원에 진심으로
              감사드립니다.
            </p>

            <p className="spacing" />

            <p>
              새로운 시작에 대한 기대와 설렘을 안고, 앞으로도 좋은 소식으로
              찾아뵙겠습니다.
            </p>
            <p>감사합니다.</p>

            <p className="signature">로컬스티치 대표 김수민 드림</p>
          </div>

          <div className="dont-show-again">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="dontShowCheckbox"
                checked={dontShowAgain}
                onChange={handleDontShowAgain}
              />
              <label htmlFor="dontShowCheckbox">오늘 하루 그만보기</label>
            </div>
            <button type="button" onClick={handleClose}>
              닫기
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        .dimd-layer {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .announcement-popup {
          position: relative;
          background-color: white;
          width: 100%;
          max-width: 650px;
          max-height: 90vh;
          overflow-y: auto;
          padding: 40px 30px;
          border-radius: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .announcement-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
        }

        .btn-close {
          position: static;
          background: none;
          border: none;
          cursor: pointer;
          line-height: 1;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .btn-close .img-close {
          display: block;
          width: 100%;
          height: 100%;
          background-image: url('/images/x-button.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }

        .announcement-content {
          text-align: left;
        }

        h2 {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 25px;
          text-align: left;
          letter-spacing: -0.5px;
          margin: 0;
        }

        .announcement-text {
          line-height: 1.5;
          margin-bottom: 30px;
          font-size: 15px;
          color: #000;
          letter-spacing: -0.5px;
        }

        .announcement-text p {
          margin-bottom: 5px;
        }

        .spacing {
          height: 10px;
        }

        .signature {
          margin-top: 20px;
          /* text-align: right; */
        }

        .dont-show-again {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #000;
          padding-top: 15px;
          padding-left: 0;
        }

        .checkbox-wrapper {
          display: flex;
          align-items: center;
          padding-left: 0;
          margin-left: 0;
        }

        .dont-show-again input[type='checkbox'] {
          appearance: none;
          -webkit-appearance: none;
          /* width: 16px; */
          /* height: 16px; */
          /* border: 1px solid #000; */
          /* border-radius: 2px; */
          /* margin-right: 8px; */
          margin-left: 0;
          position: relative;
          cursor: pointer;
          vertical-align: middle;
        }

        .dont-show-again input[type='checkbox']:checked {
          background-color: #fff;
          border-color: #ccc;
        }

        .dont-show-again input[type='checkbox']:checked:after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 5px;
          height: 10px;
          border: solid #333;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        .dont-show-again label {
          font-size: 15px;
          height: 18px;
          line-height: 18px;
          cursor: pointer;
        }

        .dont-show-again button {
          padding-bottom: 1px;
          border-bottom: 1px solid #000;
          cursor: pointer;
          font-size: 15px;
        }

        @media (max-width: 768px) {
          .announcement-popup {
            padding: 30px 20px;
          }

          h2 {
            font-size: 18px;
          }

          .announcement-text {
            font-size: 13px;
          }

          .announcement-popup {
            padding: 30px 20px;
            max-height: 70vh;
          }

          .btn-close .img-close {
            width: 20px;
            height: 20px;
          }

          .dont-show-again {
            font-size: 13px;
          }

          .dont-show-again label {
            font-size: 13px;
          }

          .dont-show-again button {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default MergerAnnouncement;
